export default {
    isAuthenticated: (state) => !!state.token,
    authStatus: (state) => state.status,
    isAdmin: (state) => {
        if (!state) return [];

        return state.isAdmin;
    },
    getClaims: (state) => {
        if (!state) return false;

        return state.claims;
    },
    getUtaPhone: (state) => {
        if (!state) return [];

        return state.utaPhone;
    },
    getPlivoPhone: (state) => {
        if (!state) return [];

        return state.plivoPhone;
    },
    getBranch: (state) => {
        if (!state) return [];

        return state.branch;
    },
};
